import { useNavigate, useLocation, useParams } from "react-router-dom";
import Dropdowns from "../components/Dropdowns.js";
import { useAppState } from "../state/AppStateContext.js";

export default function VehiclePage() {
  const nav = useNavigate();
  const { search } = useLocation();
  const { productType: ptParam } = useParams(); // /vehicle/:productType
  const params = new URLSearchParams(search);
  const ptQuery = params.get("productType");   // also support ?productType=
  const lang = params.get("lang");

  const productType = ptParam || ptQuery || undefined;

  const { setSelection } = useAppState();

  return (
    <Dropdowns
      productType={productType}
      onNext={(sel) => {
        setSelection(sel);
        nav("/review" + (lang ? `?lang=${lang}` : ""));
      }}
    />
  );
}
